import {useQuery} from "@tanstack/react-query";

import {fetchRoles, fetchRolesByOwner} from "../../services/network/role-api";
import {RECOMMENDATION_ENDPOINTS, ROLE_ENDPOINTS} from "../../services/network/endpoints";
import {RecommendationsApi} from "../../services/network/recommendation-api";

export function useFetchRecom(recommendationId:string) {
    const {data, error, isLoading} = useQuery({
        queryKey: [RECOMMENDATION_ENDPOINTS.GET, recommendationId],
        queryFn: () => RecommendationsApi.fetchRecommendation(recommendationId),
        enabled: Boolean(recommendationId),
    });

    return {
        recomData: data?.data,
        recomError: error,
        recomIsLoading: isLoading,
    };
}
